export default __webpack_public_path__ + "static/media/office1-after1.f0f3a458.jpg";